export default __webpack_public_path__ + "static/media/view-documents-and-wireframes.6a5055ef.svg";